export const secrets = {
    topHeadlinesUrl: 'https://api.news.minganci.org/v2/top-headlines',
    everythingUrl: 'https://api.news.minganci.org/v2/everything',
    googleUrl: 'https://www.googleapis.com/language/translate/v2',
    googleKey: 'AIzaSyDTiIetm0tjQfZ5JyMQL1tADQV9JeuIv2w',
}
